import { EOrganization, ERef } from '.';
import { OptimizerHyperparams } from './api';

export type LayoutHeader = {
  headerId: string;
  width: 'column' | 'layout';
};

export type AllowedLayout = {
  columns: number;
  heightPixels: number;
  layoutHeader: LayoutHeader | null;
  id: string;
  fillers: Filler[];
};

export type Filler = {
  name: string;
  pdfUrl: string;
  columns: number;
  height: number;
  id: string;
  maxOccurrences: number;
};

export type SeparatorConfig = {
  enabled: boolean;
  includeColumns: number[];
};
export const DEFAULT_SEPARATOR_CONFIG: SeparatorConfig = {
  enabled: false,
  includeColumns: []
};

type VariantConfig = {
  disabled: boolean;
};

export type BorderingConfig = {
  thickness: number;
  excludedColumns: number[];
};

export type LayoutSettingsConfig = {
  minHeight: number;
  heightIncrements: number;
  headerId?: string;
};
export const DEFAULT_LAYOUT_SETTINGS: LayoutSettingsConfig = {
  minHeight: 72,
  heightIncrements: 36
};
export type HeaderSettingsConfig = {
  headers: {
    applyToColumns: number[];
    height: number;
    url: string;
    width: number;
    id: string;
  }[];
};

export type ExternalAdsConfig = {
  bucket: string;
  momentFormattedFolder: string;
};
export const DEFAULT_EXTERNAL_ADS_CONFIG: ExternalAdsConfig = {
  bucket: 'nypa-document-migration',
  momentFormattedFolder: 'YYYY/MM-DD'
};

export type PublisherPaginationSettings = {
  enableAdSplitting: boolean;
  flowText: boolean;
  fillers: Filler[];
  allowedPublishers: ERef<EOrganization>[];
  owner: ERef<EOrganization>;
  separators: SeparatorConfig | undefined;
  variants?: VariantConfig | undefined;
  bordering?: BorderingConfig | undefined | null;
  optimizerHyperparams?: OptimizerHyperparams | undefined | null;
  layoutSettings?: LayoutSettingsConfig | undefined | null;
  headerSettings?: HeaderSettingsConfig | undefined | null;
  externalAdSettings?: ExternalAdsConfig | undefined | null;
};
